// A language field is a per-account SOW section with a machine key
// ("sow-language", shown as "Service Description") that is server-derived from
// the name (Slugifier) and immutable after creation — so it is never written
// back, only displayed (same as the TextBlocks slug).
export interface LanguageField {
  id: string;
  name: string;
  sowLanguage: string;
  position: number;
}

export interface LanguageFieldFormValues {
  name: string;
  preamble: string;
  postamble: string;
}

export const emptyLanguageFieldForm: LanguageFieldFormValues = {
  name: "",
  preamble: "",
  postamble: "",
};
